import React, { useState, useEffect } from "react";
import "./CookieBanner.css";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const cookieAccepted = localStorage.getItem("cookieAccepted");
    if (!cookieAccepted) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookieAccepted", "true");
    setShowBanner(false);
    if (window.enableAnalytics) {
      window.enableAnalytics();
    }
  };

  const handleReject = () => {
    localStorage.setItem("cookieAccepted", "false");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <p>
          Questo sito utilizza cookie tecnici e, previo consenso, cookie di
          analisi di Google Analytics per migliorare la tua esperienza. Per
          saperne di più consulta la{" "}
          <a
            href="/cookie-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy
          </a>
          .
        </p>
        <div className="cookie-banner-buttons">
          <button onClick={handleAccept}>Accetta</button>
          <button onClick={handleReject}>Rifiuta</button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
